import { ReservationSummary } from '@mews-commander/guest-profile';
import { getServiceTimeUnit } from '@mews-commander/legacy-entities/src/ducks';
import {
    getServiceTimeUnitPluralKey,
    getServiceTimeUnitSingularKey,
} from '@mews-commander/legacy-entities/src/utils/serviceTimeUnitLocalization';
import { useCommanderSelector } from '@mews-commander/utils';
import { TimeUnit } from '@mews/enums';
import { DateTime, DateTimeService, TimeUnitUtils, useTimezone } from '@mews/framework';

type useTimeUnitKeyParams = Pick<ReservationSummary, 'endUtc' | 'serviceId' | 'startUtc'>;

const getStartAndEndDates = (timeUnit: TimeUnit, startDate: DateTime, endDate: DateTime) => {
    if (timeUnit === TimeUnit.Hour) {
        return { start: startDate, end: endDate };
    }
    return {
        start: DateTimeService.startOfDay(startDate),
        end: DateTimeService.startOfDay(endDate),
    };
};

// TODO: Investigate if we can create our own utilities and hooks to replace dependencies from commander
export const useTimeUnitKey = ({ endUtc, serviceId, startUtc }: useTimeUnitKeyParams) => {
    const timezone = useTimezone();

    const timeUnit = useCommanderSelector((state) => getServiceTimeUnit(state, { id: serviceId }));
    const timeUnitSingularKey = useCommanderSelector((state) =>
        getServiceTimeUnitSingularKey(state, { id: serviceId })
    );
    const timeUnitPluralKey = useCommanderSelector((state) => getServiceTimeUnitPluralKey(state, { id: serviceId }));

    if (!timeUnit) return null;

    const timePart = TimeUnitUtils.timeUnitToDateTimePart(timeUnit);

    const startDate = DateTimeService.fromUtcString(startUtc, timezone);
    const endDate = DateTimeService.fromUtcString(endUtc, timezone);

    const { start, end } = getStartAndEndDates(timeUnit, startDate, endDate);

    const timeUnitCount = DateTimeService.diff(timePart, { roundDown: true })(end, start);
    const timeUnitKey = timeUnitCount && timeUnitCount > 1 ? timeUnitPluralKey : timeUnitSingularKey;

    return { count: timeUnitCount, unitKey: timeUnitKey };
};
